export default __webpack_public_path__ + "static/media/NotoSans-Italic.aafa3d31.woff";